<script>
const { computed, onMounted, ref } = VueCompositionAPI

import { generateShortUUID } from "utils/uuid"

import ContentModal from "Modals/ContentModal.vue"

export default {
    name: "NewChapterModal",
    components: {
        ContentModal
    },
    props: {
        delay: {
            type: Number,
            default: 3000
        },
        // give the modal a name so we can control it outside of the component
        // via the root Vue Instance / Event bus
        name: {
            type: [ String, Boolean ],
            default: "newChapterModal"
        },
        path: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
    },
    setup ( props, ctx ) {
        const email = ref( "" )

        // generate a unique key for this media modal
        // for explicit control within methods
        const key = computed( () => `${ props.name }_${ generateShortUUID() }` )

        onMounted( () => {
            setTimeout( () => {
                ctx.refs[key.value].showSelf( true )
            }, props.delay )
        })

        function submit () {
            window.butterMarketingModals.requestModal({
                callback ( proceed ) {
                    if ( proceed ) {
                        ctx.refs[key.value].showSelf( false )
                    }
                },
                formData: {
                    email: email.value,
                    hiddenMRLS: "ButterCMS.com Microservices for Startups Subscribe",
                    hiddenMRLSD: `${ props.path } - Subscribe`,
                },
                name: "newsletterSubscriptionModal",
                url: props.url,
            })
        }


        return {
            email,
            key,
            submit
        }
    }
}
</script>

<template>
<content-modal
    class="butter-modal butter-modal--newChapterModal"
    :name="name"
    :ref="key"
>
    <h1 class="NewChapterModal-head">
        Get new chapters in your inbox
    </h1>
    <div class="NewChapterModal-content">
        <form

            class="form-inline"
            @submit.prevent="submit"
            submit
        >
            <div class="form-group mb-3">
                <input
                    class="form-control"
                    name="email"
                    placeholder="Email..."
                    required
                    type="email"
                    v-model="email"
                >
            </div>
            <button
                class="button green"
                type="submit"
            >
                Subscribe
            </button>
        </form>
    </div>
</content-modal>
</template>
